import { styled } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import checked from '../../static/images/mvp/checked.png';
import FormControl from '@mui/material/FormControl';
import React from 'react';
import { InputLabel } from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import { I18n } from '@aws-amplify/core';

export const formTheme = {
  formSection: {
    fontFamily: 'Questrial',
    fontWeight: 400,
    padding: '32px 36px',
    mimWidth: '438px'
  },
  sectionHeader: {
    color: '#000000',
    fontSize: '20px',
    lineHeight: '30px',
  },
  inputLabel: {
    color: '#000000',
    fontSize: '16px',
    lineHeight: '16px',
  },
  sectionFooter: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  button: {
    backgroundColor: '#FF9900',
    borderRadius: '16px',
    padding: '22px 44px',
    fontSize: '16px',
    lineHeight: '16px',
    textTransform: 'none',
    letterSpacing: 0,
  },
  formField: {
    marginBottom: '16px'
  }
}

const CustomSelect = styled(Select)(({ theme }) => ({
  '& .MuiSelect-select': {
    color: '#11827',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    borderColor: '#CCCCCC',
    borderRadius: '4px',
    fontFamily: 'Questrial',
    padding: '14px 16px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #CCCCCC',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #CCCCCC',
  },
}));

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  '&.MuiMenuItem-root': {
    padding: '12px 16px',
    color: '#6B7280',
    '&:hover': {
      backgroundColor: '#F9FAFB',
      padding: '12px 16px',
      borderRadius: '10px',
    },
    '&.Mui-selected': {
      backgroundColor: '#F9FAFB',
      color: '#FF9900',
      padding: '12px 16px',
      borderRadius: '10px',
      '&::after': {
        content: `url(${checked})`,
        position: 'absolute',
        right: 18,
        top: '50%',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
      },
      position: 'relative'
    },
  },
}));

export const CustomSelectComponent = ({options, selectedValue, onChange, title = null, required = true, placeholder  = '' }) => (
  <FormControl fullWidth>
    {title && (
      <InputLabel theme={formTheme}>{I18n.get(`${title}`)}
        {required && (<span className="text-danger">*</span>)}
      </InputLabel>
    )}
    <CustomSelect
      value={selectedValue}
      onChange={onChange}
      MenuProps={{
        PaperProps: {
          sx: {
            border: 'none',
            borderRadius: '10px',
            padding: '16px 24px',
            '& .MuiList-root': {
              padding: '0px',
            },
          },
        },
      }}
      displayEmpty
      inputProps={{ 'aria-label': 'Without label' }}
    >
      {placeholder && (
        <MenuItem disabled value="">
          {I18n.get(`${placeholder}`)}
        </MenuItem>
      )}
      {options.map((option) => (
        <CustomMenuItem
          key={option.value} value={option.value}
          selected={option.value === selectedValue}
        >
          {option.label}
        </CustomMenuItem>
      ))}
    </CustomSelect>
  </FormControl>
);
